const YOUTUBE_URL_PATTERNS = [
  /youtu\.be\/([^#&?]{11})/, // youtu.be/<id>
  /\?v=([^#&?]{11})/, // ?v=<id>
  /&v=([^#&?]{11})/, // &v=<id>
  /embed\/([^#&?]{11})/, // embed/<id>
  /\/v\/([^#&?]{11})/, // /v/<id>
];

/**
 * See: https://github.com/jmorrell/get-youtube-id/
 */
export const extractIdFromYoutubeUrl = (youtubeUrl: string) => {
  if (!/youtu\.?be/.test(youtubeUrl)) {
    return null;
  }

  // If any pattern matches, return the ID
  const matchedPattern = YOUTUBE_URL_PATTERNS.find((pattern) => pattern.test(youtubeUrl));
  if (matchedPattern) {
    return (matchedPattern.exec(youtubeUrl) as RegExpExecArray)[1];
  }

  // If that fails, break it apart by certain characters and look
  // for the 11 character key
  const tokens = youtubeUrl.split(/[/&?=#.\s]/g);
  const matched = tokens.find((t) => /^[^#&?]{11}$/.test(t));

  if (matched) {
    return matched;
  }

  return null;
};
